import { transform, type TransformedCartData } from "../transformers/CartViewDataTransformer";
import { resolveApiUrl } from "../../../../utils/url/urlResolver";
import { registerCallProcessor, scheduleCall } from "~/features/cart/cart/api/CartService";
import { apiGET } from "~/app/api/apiCallsService";
import type { CartViewDTO } from "../dto/CartViewDTO";

const apiUrl = resolveApiUrl("/cart/view");

export async function getData(): Promise<TransformedCartData> {
  const response = await scheduleCall("cartView", {});
  const dto: CartViewDTO = await response.json();
  return transform(dto);
}

registerCallProcessor({
  type: "cartView",
  execute: async () => {
    return apiGET(apiUrl, {
      credentials: "same-origin", // include, omit
      mode: "cors", // no-cors, same-origin
      referrer: "no-referrer", // client
    });
  },
  canBeExecuted: (ongoingCalls) => {
    const isDeleteOngoing = ongoingCalls.some((call) => call.type === "delete" || call.type === "deleteCart");
    return !isDeleteOngoing;
  },
});
